import { render, staticRenderFns } from "./BtnExcluirManutencao.vue?vue&type=template&id=398a48dd&"
import script from "./BtnExcluirManutencao.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports